import { Box, LinearProgress, Typography } from '@mui/material';

interface ProgressBarProps {
  current_step: number;
  total_steps: number;
}

/**
 * A general use progress bar for tracking the completed steps of a given process.
 * @param {number} current_step The amount of steps completed so far.
 * @param {number} total_steps The amount of steps to be completed in total.
 * @returns {JSX.Element}
 */
const ProgressBar = ({ current_step, total_steps }: ProgressBarProps) => {
  const progress: number = (current_step / total_steps) * 100;
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={progress} />
      <Typography sx={{ my: 2, fontSize: '0.9rem' }}>
        Section {current_step} of {total_steps}
      </Typography>
    </Box>
  );
};

export default ProgressBar;
